<template>
  <b-container class="text-center">
    <b-row align-h="center" class="mb-5">
      <b-col cols="10" md="6">
        <!-- Q4 Path (RandomNumber == 0) -->
        <b-form-group 
          :label="formConfig[4].label"
          v-if="randomNumber === 0"
          label-class="h5"
          label-for="q4"
          :state="stateReference"
          v-slot="{ ariaDescribedBy }"
          :validated="formSubmitted"
          class="mb-4"
        >
          <b-form-radio-group buttons button-variant="outline-dark" stacked
            class="d-flex flex-column align-items-start mt-3"
            :aria-describedby="ariaDescribedBy"
            id="q4"
            name="q4"
            v-model.trim="formData[4].answer_id"
            :state="stateReference"
          >
            <b-form-radio class="btb-radio-button"
              v-for="{ text, value } in formConfig[4].options"
              :key="value"
              :value="value"
            >
              {{ text }}
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>

        <b-form-group 
          :label="formConfig[5].label"
          v-if="formData[4]?.answer_id === 31"
          label-class="h5"
          label-for="q5"
          :state="stateReference"
          v-slot="{ ariaDescribedBy }"
          :validated="formSubmitted"
          class="mb-4"
        >
          <b-form-radio-group buttons button-variant="outline-dark" stacked
            class="d-flex flex-column align-items-start mt-3"
            :aria-describedby="ariaDescribedBy"
            id="q5"
            name="q5"
            v-model.trim="formData[5].answer_id"
            :state="stateReference"
          >
            <b-form-radio class="btb-radio-button"
              v-for="{ text, value } in formConfig[5].options"
              :key="value"
              :value="value"
            >
              {{ text }}
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>

        <b-form-group 
          :label="formConfig[6].label"
          v-if="formData[4]?.answer_id === 32"
          label-class="h5"
          label-for="q6"
          :state="stateReference"
          v-slot="{ ariaDescribedBy }"
          :validated="formSubmitted"
          class="mb-4"
        >
          <b-form-radio-group buttons button-variant="outline-dark" stacked
            class="d-flex flex-column align-items-start mt-3"
            :aria-describedby="ariaDescribedBy"
            id="q6"
            name="q6"
            v-model.trim="formData[6].answer_id"
            :state="stateReference"
          >
            <b-form-radio class="btb-radio-button"
              v-for="{ text, value } in formConfig[6].options"
              :key="value"
              :value="value"
            >
              {{ text }}
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>

        <b-form-group 
          :label="formConfig[7].label"
          v-if="formData[4]?.answer_id === 33"
          label-class="h5"
          label-for="q7"
          :state="stateReference"
          v-slot="{ ariaDescribedBy }"
          :validated="formSubmitted"
          class="mb-4"
        >
          <b-form-radio-group buttons button-variant="outline-dark" stacked
            class="d-flex flex-column align-items-start mt-3"
            :aria-describedby="ariaDescribedBy"
            id="q7"
            name="q7"
            v-model.trim="formData[7].answer_id"
            :state="stateReference"
          >
            <b-form-radio class="btb-radio-button"
              v-for="{ text, value } in formConfig[7].options"
              :key="value"
              :value="value"
            >
              {{ text }}
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>

        
        <!-- Q8 Path (RandomNumber == 1) -->
        <b-form-group 
          :label="formConfig[8].label"
          v-if="randomNumber === 1"
          label-class="h5"
          label-for="q8"
          :state="stateReference"
          v-slot="{ ariaDescribedBy }"
          :validated="formSubmitted"
          class="mb-4"
        >
          <b-form-radio-group buttons button-variant="outline-dark" stacked
            class="d-flex flex-column align-items-start mt-3"
            :aria-describedby="ariaDescribedBy"
            id="q8"
            v-model.trim="formData[8].answer_id"
            :state="stateReference"
          >
            <b-form-radio class="btb-radio-button"
              v-for="{ text, value } in formConfig[8].options"
              :key="value"
              :value="value"
            >
              {{ text }}
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        
        <b-form-group 
          :label="formConfig[9].label"
          v-if="randomNumber === 1"
          label-class="h5"
          label-for="q9"
          :state="stateReference"
          v-slot="{ ariaDescribedBy }"
          :validated="formSubmitted"
          class="mb-4"
        >
          <b-form-radio-group buttons button-variant="outline-dark" stacked
            class="d-flex flex-column align-items-start mt-3"
            :aria-describedby="ariaDescribedBy"
            id="q9"
            v-model.trim="formData[9].answer_id"
            :state="stateReference"
          >
            <b-form-radio class="btb-radio-button"
              v-for="{ text, value } in formConfig[9].options"
              :key="value"
              :value="value"
            >
              {{ text }}
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>

        
        <!-- Q10 Path (RandomNumber == 2) -->
        <b-form-group 
          :label="formConfig[10].label"
          v-if="randomNumber === 2"
          label-class="h5"
          label-for="q10"
          :state="stateReference"
          v-slot="{ ariaDescribedBy }"
          :validated="formSubmitted"
          class="mb-4"
        >
          <b-form-radio-group buttons button-variant="outline-dark" stacked
            class="d-flex flex-column align-items-start mt-3"
            :aria-describedby="ariaDescribedBy"
            id="q10"
            name="q10"
            v-model.trim="formData[10].answer_id"
            :state="stateReference"
          >
            <b-form-radio class="btb-radio-button"
              v-for="{ text, value } in formConfig[10].options"
              :key="value"
              :value="value"
            >
              {{ text }}
            </b-form-radio>
          </b-form-radio-group>

          <b-form-group class="mt-3" v-if="formData[10].answer_id === 55">
            <span class="btb-form-description">Please provide response with minimum 5 characters</span>
            <b-textarea class="flex-grow-1"
              v-bind="formConfig[10].other"
              v-model.trim="formData[10].other"
            />
          </b-form-group>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { GET_SURVEY_OPTIONS, IS_BOOKER } from '@/store/getters';
import { UPDATE_HEARD_FROM, UPDATE_SURVEY_ANSWERS, GENERATE_RNG } from '@/store/mutations';
import { isOptionOther } from '@/utils';
import { SURVEYS, SURVEY_ID, SURVEY_FOLLOW_UP_RANDOM_NUMBER } from '@/store/state';
import { validateBeforeRouteLeave } from '@/utils/mixins/validateBeforeRouteLeave';

export const FOLLOW_UP_SURVEY_EVENTS = {
  COMPLETED: 'FollowUpSurvey:Completed'
}

export default {
  name: 'FollowUpSurvey',
  mixins: [
    validateBeforeRouteLeave
  ],
  props: {
    heardFrom: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        4: { answer_id: null, other: null },
        5: { answer_id: null, other: null },
        6: { answer_id: null, other: null },
        7: { answer_id: null, other: null },
        8: { answer_id: null, other: null },
        9: { answer_id: null, other: null },
        10: { answer_id: null, other: null },
      },
      formSubmitted: false
    }
  },
  computed: {
    ...mapState([
      SURVEYS,
      SURVEY_ID,
      SURVEY_FOLLOW_UP_RANDOM_NUMBER
    ]),
    ...mapGetters({
      surveyOptions: GET_SURVEY_OPTIONS,
      isBooker: IS_BOOKER
    }),
    randomNumber() {
      if(this[SURVEY_FOLLOW_UP_RANDOM_NUMBER] === undefined){
        this.$store.commit(GENERATE_RNG);
      }
      return this[SURVEY_FOLLOW_UP_RANDOM_NUMBER] ?? 0;
    },
    optionOther() {
      const options = this.formConfig?.reference?.options ?? [];
      return options.find(({ text }) => isOptionOther(text)) || {};
    },
    canProceed() {
      switch(this.randomNumber) {
        case 0:
          return !!this.formData[4].answer_id && 
            ((this.formData[4].answer_id === 31) ? !!this.formData[5].answer_id : true) &&
            ((this.formData[4].answer_id === 32) ? !!this.formData[6].answer_id : true) &&
            ((this.formData[4].answer_id === 33) ? !!this.formData[7].answer_id : true);
        case 1:
          return !!this.formData[8].answer_id && !!this.formData[9].answer_id;
        case 2:
          return !!this.formData[10].answer_id
          && ((this.formData[10].answer_id === 55) ? (this.formData[10].other && this.formData[10].other.length >= 5) : true);
        default:
          return false;
      }
    },
    formConfig() {
      return this.surveyOptions;
    },
    stateReference() {
      return this.formSubmitted ? this.canProceed : null;
    },
    cleanedOptions() {
      let options = []
    }
  },

  mounted() {
    if (this.canProceed) this.completeStep(true);

  },
  watch: {
    canProceed(fresh) {
      this.completeStep(fresh);
    }
  },
  methods: {
    completeStep(isComplete) {
      this.$emit(FOLLOW_UP_SURVEY_EVENTS.COMPLETED, isComplete ? this : null);
    },
    validateForm() {
      this.formSubmitted = true;
      return this.canProceed;
    },
    updateSurveyAnswers(){
      const answers = [];
      switch(this.randomNumber) {
        case 0:
          answers.push(this.formatAnswer(4, this.formData[4]));
          if(this.formData[4].answer_id === 31){
            answers.push(this.formatAnswer(5, this.formData[5]));
          } else if(this.formData[4].answer_id === 32){
            answers.push(this.formatAnswer(6, this.formData[6]));
          } else if(this.formData[4].answer_id === 33){
            answers.push(this.formatAnswer(7, this.formData[7]));
          }
          break;
        case 1:
          answers.push(this.formatAnswer(8, this.formData[8]));
          answers.push(this.formatAnswer(9, this.formData[9]));
          break;
        case 2:
          answers.push(this.formatAnswer(10, this.formData[10]));
          break;
      }
      this.$store.commit(UPDATE_SURVEY_ANSWERS, answers);
    },
    formatAnswer(question_id, answer){
      return {
        answer_id: answer.answer_id,
        open_text: answer.other || null,
        question_id,
        person_id: null,
        survey_id: this.$store.state[SURVEY_ID] || null,
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.updateSurveyAnswers();
    if (to.name === 'Guardian') {
      const isValid = this.validateForm();
      return next(isValid);
    }

    return next();
  }
}
</script>

<style lang="scss" scoped>

</style>
